import { render, staticRenderFns } from "./Turntable.vue?vue&type=template&id=242a1aec&scoped=true&"
import script from "./Turntable.vue?vue&type=script&lang=js&"
export * from "./Turntable.vue?vue&type=script&lang=js&"
import style0 from "./Turntable.vue?vue&type=style&index=0&id=242a1aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a1aec",
  null
  
)

export default component.exports